import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Score } from '@sc/data-access-models';
import { ScoresAddedAction, ScoresClearedAction } from './scores.actions';

@State<Score[]>({
  name: 'scores',
  defaults: [],
})
@Injectable()
export class ScoresState {
  @Action(ScoresAddedAction)
  add(ctx: StateContext<Score[]>, { scores }: ScoresAddedAction): void {
    ctx.setState([...scores]);
  }

  @Action(ScoresClearedAction)
  clear(ctx: StateContext<Score[]>): void {
    ctx.setState(null);
  }
}
